import React from 'react';
import cx from 'classnames';

import UserAccountList from '../../blocks/UserAccountList';

import styles from './UserListPage.module.scss';
import usePresenter from './UserListPage.presenter';
import getProps from './UserListPage.props';
import { UserListPageCombinedProps } from './types';
import { ButtonModal } from 'spindl-shared-components';


const UserListPage: React.FC<UserListPageCombinedProps> = (props) => {
  const {
    className,
    classes,
    userAccountList,
    buttonModal,
    setShow,
    setSelectedAccount,
    setModalType,
    selectedAccount,
    setChipProps,
    scrollContainerRef,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.userListPage;

  return (
    <div 
      className={cx(currentStyle, className)}
      ref={scrollContainerRef}
    >
      <ButtonModal
        className={styles.modalWrapper}
        {...buttonModal}
      />
      <UserAccountList
        className={cx(styles.userAccountList, classes?.userAccountList)}
        setShow={setShow}
        setSelectedAccount={setSelectedAccount}
        setModalType={setModalType}
        setChipProps={setChipProps}
        selectedAccount={selectedAccount}
        scrollContainerRef={scrollContainerRef}
        {...internalProps.userAccountList}
        {...userAccountList}/>
    </div>
  );
};

export default UserListPage;

